import React from "react";
import { Panel, Label, Field } from "lib/components";
import { getCompanySettings } from "lib/util";
import { callApi } from "lib/util/api";
import { showWarningSnackbar } from "lib/components/Snackbar";
import { showError } from "lib/components/Error";
import { MaxDaysOut } from "./MaxDaysOut";

export function QuoteStopPanel(props) {
    //Setting to null so data from detail page is picked up.
    if(props.currentStep && props.currentStep !== 0){
        return null;
    }
    return(
        <Panel fillRow rowBreakDefault={false}>
	        <Label caption="Pickup From" look="defaultBold4" widthFillWeight={2} fillRow />
          <Label caption="Deliver To" look="defaultBold4" widthFillWeight={2} fillRow />
          <Label caption="Pickup Date" look="defaultBold4" widthFillWeight={1} fillRow rowBreak/>
          <Field caption="Shipper" field="shipper" lookupModelResultField={null} onDropDownInvisible={validateShipperLocation} widthFillWeight={2} fillRow />
          <Field caption="Consignee" field="consignee" lookupModelResultField={null} widthFillWeight={2} fillRow />
          <MaxDaysOut field="ship_date" fillRow widthFillWeight={1} rowBreak currentStep={props.currentStep}/>
        </Panel>
    );
}


export function validateShipperLocation(context, callback) {
    const enforceShipperID = getCompanySettings().enforce_shipper_id;
    if (enforceShipperID === true) {
      const shipper = context.data.list[0].modelData.shipper;
      const shipperLocationId = shipper != null ? shipper.id : null;
      if (shipperLocationId != null && shipperLocationId !== '') {
        callback && callback(true);
        return;
      }
      const shipperZipCode = shipper != null ? shipper.zip_code : null;
      if (shipperZipCode != null) {
        callApi("api/portal/customer/shipper-location-validator", "POST", {zip_code: shipperZipCode}).then((isValidResponse) => {
          const isValid = isValidResponse.data[0].is_valid;
          if (isValid === false) {
            showInvalidShipperSnackbar();
            callback && callback(false);
          }
          else {
            callback && callback(true);
          }
        }).catch(reason => {
          showError("An error occurred while validating the selected shipper location", reason);
        });
      }
      else {
        callback && showInvalidShipperSnackbar();
        callback && callback(false);
      }
    }
    else {
      callback && callback(true);
    }
}

export function showInvalidShipperSnackbar() {
    showWarningSnackbar("Your account does not have any shipping locations that match this zip code so we will not be able to provide a quote.\nContact us at " + getCompanySettings().order_contact_phone + " if you need a quote picking up at this zip code.", true);
}
